'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.getParentModel = getParentModel;
exports.hasParentModel = hasParentModel;
exports.setParent = setParent;
exports.ensureParentPointerOnChildModels = ensureParentPointerOnChildModels;
exports.getPathFromRoot = getPathFromRoot;

var _ramda = require('ramda');

var _child_models = require('./child_models');

function getParentModel(model) {
  return model.__parent__;
}

function hasParentModel(model) {
  return model.__parent__ !== undefined;
}

function setParent(model, parent, path) {
  model.__parent__ = parent;
  model.__path_from_parent__ = path;
}

function ensureParentPointerOnChildModels(parentModel) {
  var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var childModels = (0, _child_models.extractChildModels)(parentModel);

  (0, _ramda.forEach)(function (child) {
    var _child = _slicedToArray(child, 2),
        model = _child[0],
        path = _child[1];

    if (force || !hasParentModel(model)) {
      setParent(model, parentModel, path);
    }
  }, childModels);
}

function getPathFromRoot(model) {
  var path = [];
  var current = model;

  while (current.__parent__) {
    path = current.__path_from_parent__.concat(path);
    current = current.__parent__;
  }

  return path;
}